import React, { FC } from 'react';
import { Card } from 'components/ui';
import { Field } from 'react-final-form';
import { SelectTagsWrapper } from 'components/forms';
import { useQuery } from '@redux-requests/react';
import { AppsConstants } from 'modules/userApps/store/constants';

const AppDistribute: FC = () => {
  const { data: countries } = useQuery({ type: AppsConstants.APP_COUNTRIES });

  return (
    <Card title='form.step.app.distribute.title'>
      <Field
        name='allowedCountries'
        component={SelectTagsWrapper}
        placeholder='form.step.app.distribute.placeholder'
        options={countries}
        isFullWidthTags
        tagsLimitHeight={119}
        hasAllOption
      />
    </Card>
  );
};

export default AppDistribute;
